'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _sync = require('./sync.xhr');

var _sync2 = _interopRequireDefault(_sync);

var _lodash = require('lodash.uniqueid');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
    function _class() {
        _classCallCheck(this, _class);

        this.pollInterval = 2000;

        this._listeners = {};
        this._xhrSyncInstance = new _sync2.default();

        return this;
    }

    _createClass(_class, [{
        key: 'query',
        value: function query() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var _this = this;

            var method = arguments[1];
            var storage = arguments[2];

            var id = void 0;

            this.stopListening(storage);

            storage._syncListenerId = id = options.listenerId || (0, _lodash2.default)('ddos_listener');
            this._listeners[id] = {};

            this.poolXHR = this._makeQuery(options, method, storage);

            // run default sync with interval
            this._listeners[id].intervalId = setInterval(function () {
                // replace listener sync on default sync
                _this.poolXHR = _this._makeQuery(options, method, storage);
            }, options.pollInterval || this.pollInterval);

            if (options.pollTimeout !== undefined) {
                // stop polling on timeout
                this._listeners[id].timeoutId = setTimeout(function () {
                    _this.stopListening(storage);

                    if (typeof options.error === 'function') {
                        options.error({ message: 'timeout' });
                    }

                    if (typeof options.complete === 'function') {
                        options.complete();
                    }
                }, options.pollTimeout);
            }

            // reference to sync, needed for stopListening
            storage.ddosSync = this;
        }

        /**
         * stop listening storage
         * @param {object} storage
         * @return {object}
         */

    }, {
        key: 'stopListening',
        value: function stopListening(storage) {
            if (storage._syncListenerId && this._listeners[storage._syncListenerId]) {
                clearInterval(this._listeners[storage._syncListenerId].intervalId);
                clearTimeout(this._listeners[storage._syncListenerId].timeoutId);
                delete this._listeners[storage._syncListenerId];
                this.poolXHR && this.poolXHR.abort();
            }

            return this;
        }
    }, {
        key: '_makeQuery',
        value: function _makeQuery() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var method = arguments[1];
            var storage = arguments[2];

            var beforeSend = options.beforeSend,
                complete = options.complete;

            if (!storage._sync_listener_active_pool) {
                options.beforeSend = function (jqXHR) {
                    storage._sync_listener_active_pool = true;

                    if (typeof beforeSend === 'function') {
                        return beforeSend(jqXHR);
                    }
                };

                options.complete = function (jqXHR) {
                    storage._sync_listener_active_pool = false;

                    if (typeof complete === 'function') {
                        return complete(jqXHR);
                    }
                };

                return this._xhrSyncInstance.query(options, method, storage);
            } else {
                return this.poolXHR;
            }
        }

        /**
         * @return {object} singleton of this class
         */

    }], [{
        key: 'getInstance',
        value: function getInstance() {
            if (!this.prototype.singletonInstance) {
                var parent = this,
                    Surrogate = void 0;

                Surrogate = function Surrogate() {
                    var _parent$prototype$con;

                    for (var _len2 = arguments.length, rest = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        rest[_key2] = arguments[_key2];
                    }

                    // для того что бы принимать динамическое к-во аргументов в конструктор
                    return (_parent$prototype$con = parent.prototype.constructor).call.apply(_parent$prototype$con, [this].concat(rest));
                };

                Surrogate.prototype = parent.prototype;

                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                this.prototype.singletonInstance = new (Function.prototype.bind.apply(Surrogate, [null].concat(args)))();
            }

            return this.prototype.singletonInstance;
        }
    }]);

    return _class;
}();

exports.default = _class;